<script setup>
import { ref, computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useScheduleStore } from '@/stores/schedule.store'
import { useWebSiteStore } from '@/stores/web-site.store'
import { usePolling } from '@/composables/polling'
import { useTaskChanges } from '@/composables/tasks'
import { signalToneEnum, signalToneColor } from '@/composables/dashboard-kpi'

const i18n = getI18n()
const scheduleStore = useScheduleStore()
const webSiteStore = useWebSiteStore()

const counts = ref({})

const attentionCount = computed(() => counts.value.needing_attention ?? 0)

const refreshCountsAsync = async() => {
  counts.value = await scheduleStore.fetchTaskCountsAsync()
}

usePolling(refreshCountsAsync)
useTaskChanges(refreshCountsAsync)
</script>

<template>
  <q-btn
    flat
    round
    dense
    icon="mdi-checkbox-marked-circle-outline"
    :aria-label="i18n.t('common.tasks.tab')"
    @click="webSiteStore.showTasks = !webSiteStore.showTasks"
  >
    <q-badge
      v-if="attentionCount > 0"
      :color="signalToneColor(signalToneEnum.ATTENTION)"
      :label="attentionCount"
      floating
      rounded
    />
    <q-tooltip>{{ i18n.t('common.tasks.tab') }}</q-tooltip>
  </q-btn>
</template>
